export default __webpack_public_path__ + "static/media/resume-intro-icon.4a077916.svg";